/** 旧ハイライト表示は廃止。会話ログ本文は通常テキストとして表示する。 */
export function HighlightedConversation({
  content,
}: {
  content: string;
  evidenceStrings: string[];
  type: "listening" | "report" | "empathy";
}) {
  return <span className="whitespace-pre-wrap">{content}</span>;
}
